import {
    APPTOOLBAR_RESET_APP_STATE,
    DRAWINGTOOLBAR_BACKGROUND_EDIT,
    DRAWINGTOOLBAR_BACKGROUND_LOADED,
    DRAWINGTOOLBAR_BACKGROUND_SHOW_HIDE,
    DRAWINGTOOLBAR_MEASURETOOL_EDIT,
    DRAWINGTOOLBAR_SCALE_EDIT,
    DRAWINGTOOLBAR_SCALE_UNIT_VALUE_CHANGE,
    SCALELINE_SET_PIXELS
} from "../lib/types";

const initialState = {
    bgEdit: false,
    chmBedPresent: false,
    scaleEdit: false,
    measureToolEdit: false,
    scalePixels: 300,
    scaleValue: 60,
};

export default (state = initialState, action) => {
    /* discriminate the action type */
    switch (action.type) {
        case DRAWINGTOOLBAR_BACKGROUND_LOADED:
            return {
                ...state,
                bgEdit: true,
                scaleEdit: false
            };

        case DRAWINGTOOLBAR_BACKGROUND_SHOW_HIDE:
            return {
                ...state,
                bgShow: action.payload
            };

        case DRAWINGTOOLBAR_BACKGROUND_EDIT:
            return {
                ...state,
                bgEdit: action.payload,
                scaleEdit: action.payload ? false : state.scaleEdit
            };

        case DRAWINGTOOLBAR_SCALE_EDIT:
            return {
                ...state,
                scaleEdit: action.payload,
                bgEdit: action.payload ? false : state.bgEdit,
                measureToolEdit: false
            };

        case DRAWINGTOOLBAR_MEASURETOOL_EDIT:
            return {
                ...state,
                // bgEdit: action.payload ? false : state.bgEdit,
                bgEdit: action.payload ? false : state.bgEdit,
                scaleEdit: action.payload,
                measureToolEdit: action.payload,
            };

        case SCALELINE_SET_PIXELS:
            return {
                ...state,
                scalePixels: action.payload
            };

        case DRAWINGTOOLBAR_SCALE_UNIT_VALUE_CHANGE:
            return {
                ...state,
                scaleValue: action.payload
            };

        case APPTOOLBAR_RESET_APP_STATE:
            return initialState;

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/drawingtoolbar-reducer.js